// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1zMsS","tab":"Tabs_tab__3Avh7","tabActive":"Tabs_tabActive__2-gxP"};